// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__P2DWh","inner":"Footer_inner__1ENi7"};